<template>
	<div>
		<DialogCadastrarFornecedor
			:abrirDialog="cadastrar"
			@loadFornecedores="loadFornecedores"
			:id="id"
			@dialogClose="dialogClose"
		/>
		<DialogExluirFornecedor
			:abrirDialog="excluir"
			:id="id"
			@loadFornecedores="loadFornecedores"
			@dialogClose="dialogClose"
		/>
		<v-row align="center" justify="center">
			<v-col md="11" xl="8">
				<CardPersonalizado titulo="Fornecedores" icone="mdi-account-tie-outline">
					<div class="cabeçalho">
						<v-row>
							<v-col cols="12" md="8" class="pa-1">
								<v-text-field
									v-model="search"
									solo
									placeholder="Procure um fornecedor"
									elevation="9"
									background-color="#FAFAFA"
									hide-details
								></v-text-field>
							</v-col>
							<v-col cols="12" md="4" class="pa-1">
								<v-btn
									class="white--text"
									color="#CC2128"
									elevation="9"
									width="100%"
									@click="cadastrarFornecedor()"
									large
								>
									<v-icon left> mdi-plus </v-icon>
									Cadastrar Fornecedor
								</v-btn>
							</v-col>
						</v-row>
					</div>
					<TabelaPersonalizada
						:headers="headers"
						:itens="fornecedores"
						:total="total"
						:loading="loading"
						@setOptions="setOptions"
						@editar="editarFornecedor"
					>
						<template v-slot:[`item.ativo`]="{ item }">
							<v-icon small class="mr-2">
								{{ retornarIcone(item.ativo) }}
							</v-icon>
						</template>
					</TabelaPersonalizada>
				</CardPersonalizado>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import CardPersonalizado from '../components/shared/cardPersonalizado.vue'
import TabelaPersonalizada from '../components/shared/tabelaPersonalizada.vue'
import DialogCadastrarFornecedor from '../components/fornecedores/DialogCadastrarFornecedor'
import DialogExluirFornecedor from '../components/fornecedores/DialogExcluirFornecedor.vue'

import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			fornecedores: [],
			fornecedor: {},
			search: '',
			editar: false,
			id: '',
			cadastrar: false,
			total: 0,
			excluir: false,
			loading: false,
			options: {},
			headers: [
				{ text: 'Razão social', value: 'razaoSocial', sortable: false },
				{ text: 'Nome Fantasia', value: 'nomeFantasia', sortable: false },
				{ text: 'CNPJ', value: 'cpfCnpj', sortable: false },
				{ text: 'E-mail', value: 'email', sortable: false },
				{ text: 'Ativo', value: 'ativo', algin: 'center', sortable: false },
			],
		}
	},
	components: {
		CardPersonalizado,
		TabelaPersonalizada,
		DialogCadastrarFornecedor,
		DialogExluirFornecedor,
	},
	methods: {
		async loadFornecedores() {
			try {
				this.loading = true

				const { page, itemsPerPage } = this.options
				const response = await this.axios.get('/fornecedores', {
					params: {
						search: this.search,
						limit: itemsPerPage,
						page,
					},
				})
				this.fornecedores = response.data.fornecedores
				this.total = response.data.total
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		setOptions(options) {
			this.options = options
			this.loadFornecedores()
		},
		cadastrarFornecedor() {
			this.cadastrar = true
		},
		editarFornecedor(id) {
			this.id = id
			this.cadastrar = true
		},
		excluirFornecedor(id) {
			this.id = id
			this.excluir = true
		},
		dialogClose() {
			this.loadFornecedores()
			this.cadastrar = false
			this.editar = false
			this.excluir = false
			this.id = ''
		},
	},
	mounted() {
		this.loadFornecedores()
	},
	computed: {
		...mapGetters(['userAdmin', 'userMaster']),
	},
	watch: {
		search() {
			this.loadFornecedores()
			this.options.page = 1
		},
	},
}
</script>

<style scoped>
.cabeçalho {
	padding: 8px 8px 0 8px;
	margin-bottom: 20px;
}
.col {
	padding: 4px;
}
</style>